<script setup lang="ts">
import { useAppStore } from '@/store/app'

const appStore = useAppStore()
</script>

<template>
  <RouterView v-if="appStore.appReady || appStore.iosError" />
  <AppLoader v-else />
  <!-- <DebugConsole /> -->
</template>
